export { EmojiMeh as default } from './EmojiMeh';
